import { useEffect, useRef, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import Arrow from './redesign/Arrow';
const links = [['/company', '会社情報'], ['/service', '事業紹介'], ['/#products', '自社サービス'], ['/works', '相談事例・実績'], ['/recruit', '採用情報']];
export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const toggleRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLElement>(null);
  useEffect(() => { setOpen(false); }, [location]);
  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', update, { passive: true }); update();
    return () => window.removeEventListener('scroll', update);
  }, []);
  useEffect(() => {
    if (!open) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    menuRef.current?.querySelector<HTMLAnchorElement>('a')?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { setOpen(false); toggleRef.current?.focus(); }
      if (event.key === 'Tab') {
        const items = [toggleRef.current, ...Array.from(menuRef.current?.querySelectorAll<HTMLAnchorElement>('a') || [])].filter(Boolean) as HTMLElement[];
        const current = items.indexOf(document.activeElement as HTMLElement);
        const next = event.shiftKey ? (current - 1 + items.length) % items.length : (current + 1) % items.length;
        event.preventDefault(); items[next]?.focus();
      }
    };
    const onResize = () => { if (window.innerWidth > 960) setOpen(false); };
    document.addEventListener('keydown', onKey); window.addEventListener('resize', onResize);
    return () => { document.body.style.overflow = previousOverflow; document.removeEventListener('keydown', onKey); window.removeEventListener('resize', onResize); };
  }, [open]);
  return <>
    <a className="skip-link" href="#main-content">本文へ移動</a>
    <header className={`site-header ${scrolled ? 'is-scrolled' : ''} ${open ? 'menu-is-open' : ''}`}>
      <Link className="brand" to="/" aria-label="FRiCTON トップページ"><img src="/images/fricton_logo.png" alt="FRiCTON" /></Link>
      <nav className="desktop-nav" aria-label="メインナビゲーション">
        {links.map(([path, label]) => path.includes('#') ? <Link key={path} to={path}>{label}</Link> : <NavLink key={path} to={path}>{label}</NavLink>)}
        <Link className="header-contact" to="/contact">お問い合わせ <Arrow /></Link>
      </nav>
      <button ref={toggleRef} className="menu-toggle" aria-expanded={open} aria-controls="mobile-navigation" aria-label={open ? 'メニューを閉じる' : 'メニューを開く'} onClick={() => setOpen(!open)}><span /><span /></button>
    </header>
    <nav ref={menuRef} id="mobile-navigation" className="mobile-nav" aria-label="モバイルナビゲーション" hidden={!open}>
      {links.map(([path, label]) => <Link key={path} to={path}>{label}<Arrow /></Link>)}
      <Link className="mobile-contact" to="/contact">お問い合わせ <Arrow /></Link>
    </nav>
  </>;
}
